module.exports = __webpack_public_path__ + "img/icon_sportMenu_champion.777ab84e.svg";